import { IS_TRAILING_SLASH_ENABLED } from '@monoimin/constants';

import { handlePathnameSlashes } from './handlePathnameSlashes';

export const adjustPathname = (pathname?: string) => {
  const preventAdjusting = pathname === '/' || pathname === '' || !pathname;

  if (preventAdjusting) {
    return '/';
  }

  return handlePathnameSlashes(pathname, IS_TRAILING_SLASH_ENABLED);
};

export default adjustPathname;
